import type {
  PreAppointmentPurposeData,
  SelectedPurposeOption,
  UpdateAppointmentPurposePayload,
} from './PreAppointmentPurpose.types'
import { PURPOSE_CATEGORY_NAME } from './PreAppointmentPurpose.types'

export const hasPurposeInput = (
  selectedOption: SelectedPurposeOption | null,
  notes: string,
): boolean => selectedOption !== null || notes.trim().length > 0

export const buildUpdateAppointmentPurposePayload = (
  bookingId: string,
  selectedOption: SelectedPurposeOption | null,
  notes: string,
): UpdateAppointmentPurposePayload => {
  const selections = selectedOption
    ? [{ category: PURPOSE_CATEGORY_NAME, value: selectedOption.value }]
    : []

  return {
    visitId: bookingId,
    selections,
    notes: notes.trim(),
    ...(selectedOption?.waitwhileServiceId
      ? { serviceId: selectedOption.waitwhileServiceId }
      : {}),
    ...(selectedOption?.duration !== undefined
      ? { duration: selectedOption.duration }
      : {}),
  }
}

export const getActivePurposeOptions = (data?: PreAppointmentPurposeData) => {
  const category = data?.categories.find(
    (item) => item.categoryName === PURPOSE_CATEGORY_NAME,
  )
  return {
    category,
    options: category?.options?.filter((option) => option.isActive) ?? [],
  }
}
